import { render } from "./modal-remove.vue?vue&type=template&id=1799e9d4&scoped=true"
import script from "./modal-remove.vue?vue&type=script&lang=js"
export * from "./modal-remove.vue?vue&type=script&lang=js"

import "./modal-remove.vue?vue&type=style&index=0&id=1799e9d4&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1799e9d4"],['__file',"src/components/admin-dashboard/modals/modal-remove.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1799e9d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1799e9d4', __exports__)) {
    api.reload('1799e9d4', __exports__)
  }
  
  module.hot.accept("./modal-remove.vue?vue&type=template&id=1799e9d4&scoped=true", () => {
    api.rerender('1799e9d4', render)
  })

}


export default __exports__